import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2Icon, ChevronRightIcon, TriangleAlertIcon } from '@/shared/ui/icons';
import { formatUsd } from '@/shared/utils/currency';
import { cn } from '@/shared/utils/cn';
import { useMyCharges } from '@/entities/charges';
import { FeaturesCargoIdDebtDialog } from './DebtDialog';

// Compact debt status row for the approved Cargo ID card: green when nothing
// is owed, red with the total otherwise. Tapping opens the itemised list.
export const FeaturesCargoIdDebtRow = () => {
  const { t } = useTranslation('cargoId');
  const [open, setOpen] = useState(false);
  const query = useMyCharges();

  if (query.isLoading) {
    return <span className="block h-11 w-full animate-pulse rounded-xl bg-brand-100" aria-hidden />;
  }

  const total = Number(query.data?.total_debt ?? 0);
  const hasDebt = total > 0;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn(
          'flex min-h-11 w-full cursor-pointer items-center gap-2 rounded-xl border px-3 py-2 text-left transition-colors',
          query.isError
            ? 'border-slate-200 bg-white text-ink-muted hover:bg-slate-50'
            : hasDebt
              ? 'border-red-200 bg-red-50 text-red-700 hover:bg-red-100'
              : 'border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100',
        )}
      >
        {query.isError ? (
          <span className="min-w-0 flex-1 truncate text-sm">{t('debt.loadError')}</span>
        ) : hasDebt ? (
          <>
            <TriangleAlertIcon className="h-4 w-4 shrink-0" aria-hidden />
            <span className="min-w-0 flex-1 truncate text-sm font-medium">{t('debt.label')}</span>
            <span className="shrink-0 text-base font-bold">{formatUsd(total)}</span>
          </>
        ) : (
          <>
            <CheckCircle2Icon className="h-4 w-4 shrink-0" aria-hidden />
            <span className="min-w-0 flex-1 truncate text-sm font-medium">{t('debt.none')}</span>
          </>
        )}
        <ChevronRightIcon className="h-4 w-4 shrink-0 opacity-70" aria-hidden />
      </button>

      <FeaturesCargoIdDebtDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
